import { createAsyncThunk } from "@reduxjs/toolkit";


import { dataServer, fetchDummyData } from "~/constants";

import { fetchSurveyData } from "~/slices/demiData";
import { setSurveyDataByType, type SurveyDataType } from "~/slices/historySlice";
import type { RootState } from "~/store";

type GetSurveyDataThunkArgs = {
  surveyId: number;
  dataType?: SurveyDataType;
  orgId?: number;
  bid?: number;
  forceRefresh?: boolean;
};

export const getSurveyData = createAsyncThunk(
  "survey/getSurveyData",
  async (
    { surveyId, dataType = "survey", orgId, bid, forceRefresh = false }: GetSurveyDataThunkArgs,
    { rejectWithValue, getState, dispatch }
  ) => {
    try {
      const state = getState() as RootState;
      const asset = state.asset.asset;
      const resolvedOrgId = orgId ?? asset?.organization_id;
      const resolvedBid = bid ?? asset?.bid;

      if (!resolvedOrgId || !resolvedBid) {
        throw new Error("Missing organization_id or bid on selected asset");
      }

      const surveyHistory = state.history.bySurveyId[String(surveyId)];
      if (surveyHistory && surveyHistory[dataType] !== undefined && !forceRefresh) {
        return {
          surveyId,
          dataType,
          data: surveyHistory[dataType],
          fromCache: true,
        };
      }

      const response = await fetch(
        `${dataServer}surveys/${surveyId}/data/${dataType}?orgId=${resolvedOrgId}&bid=${resolvedBid}`
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch survey ${dataType}`);
      }

      const data = await response.json();

      dispatch(
        setSurveyDataByType({
          surveyId,
          dataType,
          data,
        })
      );

      return {
        surveyId,
        dataType,
        data,
        fromCache: false,
      };
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to fetch survey data");
    }
  }
);

export const getSurvey = async ({ surveyId, orgId, bid, providerId }: { surveyId: number; orgId: number, bid: number, providerId?: number | null }) => {
  try {
    const response = await fetch(`${dataServer}surveys/${surveyId}?orgId=${orgId}&bid=${bid}${providerId ? `&providerId=${providerId}` : ''}`);
    if (!response.ok) {
      throw new Error("Failed to fetch organization");
    }

    const data = await response.json();

    // Create and dispatch modelsCalibration if models exist


    return data;
  } catch (error: any) {
    console.log("Error in fetchSurvey", error);
    return error.message;
  }
}
export const fetchSurvey = createAsyncThunk(
  "organization/fetchSurvey",
  async ({ surveyId, orgId, bid, providerId }:
    { surveyId: number; orgId: number, bid: number, providerId?: number | null }, { rejectWithValue, dispatch, getState }) => {

    let time = new Date().getTime();
    try {
      // const response = await fetch(`${dataServer}surveys/${surveyId}?orgId=${orgId}&bid=${bid}${providerId ? `&providerId=${providerId}` : ''}`);
      // if (!response.ok) {
      //   throw new Error("Failed to fetch organization");
      // }
      const data = await getSurvey({ surveyId, orgId, bid, providerId });
      time = new Date().getTime() - time;
      console.log("fetchSurvey time", time);

      // Create and dispatch modelsCalibration if models exist


      return data;
    } catch (error: any) {
      console.log("Error in fetchSurvey", error);
      return rejectWithValue(error.message);
    }
  }
);
export const fetchSurveyFiles = createAsyncThunk(
  "organization/fetchSurveyFiles",
  async ({ surveyId, orgId, bid }:
    { surveyId: number; orgId: number, bid: number }, { rejectWithValue, dispatch, getState }) => {
    console.log("fetchSurveyFiles called with", { surveyId, orgId, bid });
    if (fetchDummyData) return fetchSurveyData;
    let time = new Date().getTime();
    try {
      const response = await fetch(`${dataServer}survey-files/${surveyId}?orgId=${orgId}&bid=${bid}`);
      if (!response.ok) {
        throw new Error("Failed to fetch survey files");
      }
      time = new Date().getTime() - time;
      console.log("fetchSurveyFiles time", time);
      const data = await response.json();

      // Create and dispatch modelsCalibration if models exist


      return data;
    } catch (error: any) {
      console.log("Error in fetchSurveyFiles", error);
      return rejectWithValue(error.message);
    }
  }
);

